import React, { useState, useEffect, useRef, createRef } from 'react'
import PropTypes from 'prop-types'
import { Map as Maps, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react'
import Slider from 'react-slick'
import get from 'lodash.get'
import { Col, Row, Container, Spinner } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'

import Typography from 'components/atoms/Typography'
import { userCheckMobileScreen } from 'helpers/tools'

import 'slick-carousel/slick/slick.css'
import './Map.scss'

function Map(props) {
  const [isMobile, setIsMobile] = useState(false)
  const ref = useRef([])
  const infoWindowRef = useRef(null)
  const inputRef = createRef(null)
  const { title, description, addresses } = get(props, 'data')
  const themeClasses = get(props, 'data.theme.entity.classes')
  const google = get(props, 'google')
  const initialPosition = { lat: -25.45537749613251, lng: -49.28637305322338 }

  useEffect(() => {
    setIsMobile(userCheckMobileScreen())
  }, [])

  const [infowindow, setInfoWindow] = useState({
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: null,
  })

  const locations = addresses.map((item) => {
    return {
      uuid: item?.entity?.uuid,
      lat: item?.entity?.latitude,
      lng: item?.entity?.longitude,
      title: item?.entity?.title,
      zipcode: item?.entity?.zipcode,
      number: item?.entity?.number,
      country: item?.entity?.country,
      neighborhood: item?.entity?.address3,
      complement: item?.entity?.address2,
      street: item?.entity?.address1,
      city: item?.entity?.city,
    }
  })

  const onMarkerClick = (props, marker, e) => {
    setInfoWindow({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    })
  }

  const onMapClicked = () => {
    if (infowindow.showingInfoWindow) {
      setInfoWindow({
        showingInfoWindow: false,
        activeMarker: null,
      })
    }
  }

  const onSelectAddress = (data) => {
    const refActualAddress = ref.current.find((el) => el.marker.address.uuid === data.uuid)

    setInfoWindow({
      selectedPlace: refActualAddress.props,
      activeMarker: refActualAddress.marker,
      showingInfoWindow: true,
    })
  }

  const renderContentMarker = (data) => {
    const { title } = data
    const { neighborhood, street, number, complement, zipcode, city, state } = data.address

    const addressSummary = [street, number, complement, neighborhood].filter((n) => n).join(', ')
    const citySumary = [city, state].filter((n) => n).join(', ')

    return (
      <div className="maps-content__marker">
        <Typography variant="p" color="green-dark-100 font-weight-bold">
          Como chegar?
        </Typography>

        <input type="text" id="search_map" ref={inputRef} placeholder="Endereço, CEP ou cidade" />
        <Typography variant="p" color="green-dark-100 font-weight-bold">
          {title}
        </Typography>
        <Typography variant="p">{addressSummary}</Typography>
        <Typography variant="p">CEP: {zipcode}</Typography>
        <Typography variant="p">Cidade: {citySumary}</Typography>
      </div>
    )
  }

  const renderListAddress = (address) => {
    const { title, street, number, complement, zipcode, city, state, neighborhood, uuid } = address
    const addressSummary = [street, number, complement, neighborhood].filter((value) => value).join(', ')
    const citySumary = [city, state].filter((value) => value).join(', ')

    return (
      <li key={uuid} className="mb-3 location-items" onClick={() => onSelectAddress(address)}>
        <button className="card card-primary outline p-3 w-100 text-left">
          <Typography variant="p" cssClass="location-items__title">
            <b>{title}</b>
          </Typography>
          <Typography variant="p" cssClass="text-gray-100 text-left">
            {addressSummary}
          </Typography>
          <Typography variant="p" cssClass="text-small text-gray-100">
            CEP: {zipcode}
          </Typography>
          {citySumary && <Typography variant="p">Cidade: {citySumary} </Typography>}
        </button>
      </li>
    )
  }

  const renderListSlider = (address) => {
    const { title, street, number, complement, zipcode, city, state, neighborhood, uuid } = address
    const addressSummary = [street, number, complement, neighborhood].filter((value) => value).join(', ')
    const citySumary = [city, state].filter((value) => value).join(', ')

    return (
      <button
        key={uuid}
        className="card card-primary outline p-3 d-flex align-items-center justify-content-center h-100"
        onClick={() => onSelectAddress(address)}
      >
        <Typography variant="p" cssClass="subtitle-bold-sm">
          <b>{title}</b>
        </Typography>
        <Typography variant="p">{addressSummary}</Typography>
        <Typography variant="p" cssClass="text-small">
          CEP: {zipcode}
        </Typography>
        {citySumary && <Typography variant="p">Cidade: {citySumary} </Typography>}
      </button>
    )
  }

  const windowHasOpened = (el) => {
    if (infowindow.showingInfoWindow) {
      const { google, map } = get(infoWindowRef, 'current.props')

      const options = { componentRestrictions: { country: 'BR' } }
      const destinationAutocomplete = new google.maps.places.Autocomplete(
        document.getElementById('search_map'),
        options
      )
      const directionsService = new google.maps.DirectionsService()
      const directionsDisplay = new google.maps.DirectionsRenderer()

      destinationAutocomplete.addListener('place_changed', () => {
        directionsDisplay.setMap(map)

        const { lat, lng } = infowindow.selectedPlace.address
        const place = destinationAutocomplete.getPlace()
        const request = {
          origin: new google.maps.LatLng(lat, lng),
          destination: { placeId: place.place_id },
          travelMode: google.maps.TravelMode.DRIVING,
        }

        directionsService.route(request, function (response, status) {
          if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response)
          }
        })
      })
    }
  }

  return (
    <Container className={`maps ${themeClasses} section-spacing`}>
      {title && (
        <Container>
          <Row>
            <Col>
              <Typography variant="h2" cssClass="title-semibold-lg title-text mb-3">
                {title}
              </Typography>
            </Col>
          </Row>
        </Container>
      )}
      <Container>
        <Row>
          <Col className="maps__filter" xs={12} md={4}>
            <Typography variant="p" color="gray-100" cssClass="title-filter mb-2">
              Busque por unidade ou endereço:
            </Typography>

            {isMobile ? (
              <Slider arrows={false} dots={true} dotsClass="slick-dots primary" infinite={false} slidesToShow={1.1}>
                {locations?.map((address) => renderListSlider(address))}
              </Slider>
            ) : (
              <ul className="maps__locations">{locations?.map((address) => renderListAddress(address))} </ul>
            )}
          </Col>

          <Col className="maps-content" xs={12} md={8}>
            {google ? (
              <Maps
                google={google}
                onClick={onMapClicked}
                className={'map'}
                center={locations[0] || initialPosition}
                initialCenter={locations[0] || initialPosition}
                zoom={locations.length === 1 ? 18 : 13}
                style={{ height: 650 }}
              >
                {locations.map((address, index) => (
                  <Marker
                    key={address.title + index}
                    title={address.title}
                    onClick={onMarkerClick}
                    address={address}
                    position={{ lat: address?.lat, lng: address?.lng }}
                    name={address.title}
                    ref={(el) => (ref.current[index] = el)}
                  />
                ))}
                {infowindow?.selectedPlace && (
                  <InfoWindow
                    marker={infowindow.activeMarker}
                    visible={infowindow.showingInfoWindow}
                    onOpen={windowHasOpened}
                    ref={infoWindowRef}
                  >
                    {renderContentMarker(infowindow.selectedPlace)}
                  </InfoWindow>
                )}
              </Maps>
            ) : (
              <div className="d-flex">
                <Spinner animation="border" size="md" />
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col xs={12} md={12} className={`description-text mt-2`}>
            <Typography variant="span">{ReactHtmlParser(description?.value)}</Typography>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

Map.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  addresses: PropTypes.object,
}

export default GoogleApiWrapper((props) => ({
  apiKey: process.env.RAZZLE_MAPS_TOKEN,
  language: 'pt-BR',
  libraries: ['places'],
  LoadingContainer: () => <Map {...props} />,
}))(Map)
